import {
    GET_SCORECARD_LIST_SUCCESS,
    GET_SCORECARD_LIST_FAILURE

} from './actions.js'
const scorecardReducer = (state = {
    scorecardList: []
}, action) => {
    switch (action.type) {
        case GET_SCORECARD_LIST_SUCCESS:
            state = {
                ...state,
                scorecardList: action.data
            };
            break;
        case GET_SCORECARD_LIST_FAILURE:
            state = {
                ...state,
                scorecardList: action.data
            };
            break;
        default: return state;
    }
    return state;
};

export default scorecardReducer;